import getPicked from 'lodash/pick';

import React, {
  useContext,
  forwardRef,
} from 'react';
import styled from 'styled-components';

import AntdButton from 'antd/lib/button';

import Admin from 'hive-admin';
import Form from 'hive-admin/src/components/Form';
import { Tooltip } from 'hive-admin/src/components/Popover';
import ClipboardContext from 'hive-admin/src/components/ClipboardContext';

// export const PopoverContainerRef = React.createRef();
// export const PopoverContainer = styled.div`
//   position: absolute;
//   top: 0px;
//   left: 0px;
//   width: 100%;
//   z-index: 99999999999;
//   & > div:has(> div > div):not(:last-of-type) {
//     display: none;
//   }
// `;

// PopoverContainer.defaultProps = {
//   id: 'TARGETABLE_POPOVER_CONTAINER',
// };

export const TargetableFieldButton = styled(AntdButton)`
  padding: 0px;
  height: initial;
`;

export function TargetableFieldPopover({
  targetId,
  targetPath,
  allConfig,
  skip,
  small,
  isContentBuilderField,
  children,
  fieldName,
  realm = 'ContentBuilderComponent:Field',
}) {
  const clipboardContext = useContext(ClipboardContext);
  if (skip) {
    return children;
  }
  const target = `${targetId}@${targetPath}`;
  return (
    <Tooltip
      // getPopupContainer={() => PopoverContainerRef.current}
      destroyTooltipOnHide
      placement="left"
      // visible
      align={
        isContentBuilderField
        ? { offset: [-8, -5] }
        : small
        ? { offset: [-4, 0] }
        : { offset: [-8, -5] }
      }
      title={(
        <TargetableFieldButton
          icon="copy"
          type="link"
          onClick={() => {
            clipboardContext.setValue({
              realm,
              payload: {
                fieldType: allConfig[Admin.LIBRARY_NAME_KEY],
                fieldConfig: TargetableFieldPopover.getConfig(allConfig),
                targets: [{ value: target }],
              },
            });
            Admin.showMessage('Field Copied!');
          }}
        >
          Field
        </TargetableFieldButton>
      )}
    >
      {
        React.cloneElement(children, {
          'data-field-name': fieldName,
        })
      }
      {/* {children} */}
    </Tooltip>
  );
}

TargetableFieldPopover.getConfig = (allConfig) => {
  const config = getPicked(allConfig, [
    'placeholder',
    'initialValue',
    'prefix',
    'suffix',
    'addonAfter',
    'addonBefore',
    'choices',
    'block',
    'type',
    // FieldUploadRefs / FieldUploadRefsHorizontal
    'accept',
    'transformations',
    'listType',
    'uploadLabel',
    'maxCount',
    'i18nTranslatable',
  ]);
  if (!Number.isFinite(config.maxCount)) {
    delete config.maxCount;
  }
  if (config.choices) {
    config.choices = config.choices.map((choice) => {
      if (choice.labelText) {
        choice = { ...choice, label: choice.labelText };
        delete choice.labelText;
      }
      return choice;
    });
  }
  return config;
};

export const TargetableFieldsForm = forwardRef(
  (props, ref) => {
    const formRender = (
      <Form
        {...props}
        ref={ref}
        // value={console.log(props.data) || props.data}
        renderFields={(
          props.contentBuilderTargetable
          ? (fields, form) => {
              const fieldsRender = fields.map((field) => {
                const fieldRender = form.renderField(field);
                if (
                  fieldRender
                  && field.isField
                  && field.targetable !== false
                  && (
                    ['FieldTitle', 'FieldTitleToggle'].includes(
                      field[Admin.LIBRARY_NAME_KEY]
                    ) === false
                    || field.targetable === true
                  )
                ) {
                  return (
                    <TargetableFieldPopover
                      key={field.id || field.name}
                      targetId={props.data._id}
                      targetPath={field.targetableName || field.name}
                      allConfig={field}
                      fieldName={field[Admin.LIBRARY_NAME_KEY]}
                      isContentBuilderField={field.isContentBuilderField}
                      realm={props.contentBuilderTargetableRealm}
                    >
                      {fieldRender}
                    </TargetableFieldPopover>
                  );
                }
                return fieldRender;
              });
              return fieldsRender;
            }
          : undefined
        )}
      />
    );
    return formRender;
  },
);
